<template>
  <div class="main-page user-applications-page">
    <div class="container">
      <p class="user-applications-page-title">Your Application</p>
      <table v-if="userapp" class="table table-bordered user-application-table">
        <tr>
          <td>Action</td>
          <td v-if="userapp.app_type == 'MP'">
            <router-link :to="{ name:'merchant' }"><b-button>Continue application</b-button></router-link>
          </td>
          <td v-else-if="userapp.app_type == 'EC'">
            <router-link :to="{ name:'echeck' }"><b-button>Continue application</b-button></router-link>
          </td>
          <td v-else-if="userapp.app_type == 'CR'">
            <router-link :to="{ name:'crypto' }"><b-button>Continue application</b-button></router-link>
          </td>
          <td v-else-if="userapp.app_type == 'CS'">
            <router-link :to="{ name:'chargeback' }"><b-button>Continue application</b-button></router-link>
          </td>
        </tr>        
        <tr>
          <td>Created On</td>
          <td>{{userapp.created}}</td>
        </tr>
        <tr>
          <td>Application ID</td>
          <td>{{userapp.uid}}</td>
        </tr>
        <tr>
          <td>Type</td>
          <td>{{userapp.app_name}}</td>
        </tr>
        <tr>
          <td>Last Updated On</td>
          <td>{{userapp.updated}} - {{userapp.updated_time}}</td>
        </tr>
        <tr>
          <td>Status</td>
          <td>{{userapp.status}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
  }),
  computed:{
    appCode () {
    return this.$store.state.appCode
  },
  userapp () {
    return this.$store.state.userapp
  }},
  mounted() {
    this.$store.dispatch("loadUserapp", this.appCode);
  },
  methods: {
   
  }
};
</script>

<style>
.user-applications-page {
  margin-bottom: 100px;
}

.user-application-table {
  margin-bottom: 50px;
}

.user-application-table tr td:first-child {
  font-weight: 500;
  background: #fafafa;
}

.user-applications-page-title {
  font-size: 40px;
  font-weight: 500;
  text-align: center;
}
</style>